import React from 'react';

import Pic1 from '../../InstallImages/Modules/Pan330AC';


const pan330ACLink = <a href="https://www.dropbox.com/s/73ro4fcs8bjb6sq/Panasonic%20HIT%C2%AE%20AC%20Series%20Advantage_330W%2C%2096C%2C%2040mm%2C%20%28%241.26%3AW%29_VBHN330SA17E.pdf?dl=0;" rel="noopener noreferrer" target="_blank">Data Sheet</a>;

const Module = () => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">
            <p className="specsText">
                HIT® AC Series Module combines the efficiency of HIT® solar panels with the intelligence of Enphase microinverters. An Enphase IQ 7X microinverter with Individual MPPT tracking (Module-level Power Point Tracker) is integrated with HIT® high efficiency solar technology to deliver maximum power production from every roof size and shape. The AC Series alternative energy source offers extreme efficiency and high power output for residential solar systems.
            </p>
            <p className="specsText">
                Panasonic solar panels are backed by our industry-leading performance warranty that guarantees minimum power output of 90.76% after 25 years.
            </p>
            <ul> <h1>Key Features</h1>
                <li className="specsText">HIT® 330W AC Series solar module with integrated Enphase IQ 7X microinverter</li>
                <li className="specsText">All-in-one smart panel enables more power, easier installations, lower costs, and higher ROI</li>
                <li className="specsText">Built-in intelligence for greater design flexibility and higher power efficiency</li>
                <li className="specsText">Field-replaceable microinverter and no DC wire management required yields lower cost of ownership</li>
                <li className="specsText">25-year TripleGuard warranty provides complete system protection</li>
                <li className="specsText">Improved safety and protection when inverter or grid power is shut down</li>
                <li className="specsText">{pan330ACLink}</li>
            </ul>
        </div>
    </div>
);

export default Module;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Panels/pan330ac.js